export function getFirstDayOfMonth(month: number): Date {
    // Validate input
    if (!Number.isInteger(month) || month < 1 || month > 12) {
      throw new Error('Month must be a number between 1 and 12');
    }
    
    // Get the current year
    const currentYear = new Date().getFullYear();
    
    // Create a new Date object for the first day of the specified month
    // Note: In JavaScript, months are 0-indexed (0 = January, 11 = December)
    return new Date(currentYear, month - 1, 1);
  }


export const maximos= [
    {
        x: getFirstDayOfMonth(1),
        y: 35988.48
    },
    {
        x: getFirstDayOfMonth(2),
        y: 32558.44
    },
    {
        x: getFirstDayOfMonth(3),
        y: 44452.15
    },
    {
        x: getFirstDayOfMonth(4),
        y: 40542.24
    },
    {
        x: getFirstDayOfMonth(5),
        y: 64839.50
    },
    {
        x: getFirstDayOfMonth(6),
        y: 64725.77
    },
    {
        x: getFirstDayOfMonth(7),
        y: 94672.71
    },
    {
        x: getFirstDayOfMonth(8),
        y: 24363.63
    },
    {
        x: getFirstDayOfMonth(9),
        y: 71715.85
    },
    {
        x: getFirstDayOfMonth(10),
        y: 70647.07
    },
    {
        x: getFirstDayOfMonth(11),
        y: 58782.94
    },
    {
        x: getFirstDayOfMonth(12),
        y: 36678.80
    },
]